

















import { Banner } from '@empathy/search-types';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { TrackClickEvents } from '../../models';
import { TrackClickMixin } from '../mixins/trackable-click.mixin';

const DefaultBannerTrackingClickEvents: TrackClickEvents = {
  click: EVENTS.BannerClicked,
  rightClick: EVENTS.BannerRightClicked
};

@Component
export default class DefaultBanner extends Mixins(TrackClickMixin) {
  // Object & Arrays prop defaults must be returned from a function https://vuejs.org/v2/guide/components-props.html
  @Prop({ default: () => DefaultBannerTrackingClickEvents })
  clickEvents: TrackClickEvents;

  @Prop({ required: true })
  item: Banner;

  brokenImageLink = false;
}
